module.exports = __webpack_public_path__ + "img/06.f5999f62.png";